import { Outlet } from 'react-router-dom'
import Sidebar from '../../components/Dashboard/Sidebar'
import './Dashboard.css'

function Dashboard() {
  return (
    <div className="dashboard">
      <Sidebar />
      <main className="dashboard-content">
        <Outlet />
      </main>
    </div>
  )
}

export default Dashboard
